import React, { forwardRef } from 'react';
import DropdownComponent from './DropdownComponent.js';
import { DropdownProvider } from './DropdownContext.js';
import DropdownDivider from './DropdownDivider.js';
import Item from './DropdownItem.js';
import DropdownSubMenu from './DropdownSubMenu.js';
import DropdownToggle from './DropdownToggle.js';
import { DropdownHeader } from './styles.js';

const Dropdown = forwardRef((props, ref) => (React.createElement(DropdownProvider, null,
    React.createElement(DropdownComponent, Object.assign({}, props, { ref: ref })))));
Dropdown.displayName = 'Dropdown';
const DropdownNamespace = Object.assign(Dropdown, {
    Item: Item,
    SubMenu: DropdownSubMenu,
    Divider: DropdownDivider,
    Toggle: DropdownToggle,
    Header: DropdownHeader,
});

export { DropdownNamespace as default };
